/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Icon, Tooltip } from '@pwc/pwc-deals-ui';
import { isReportLivePreview } from 'common/helpers/featureFlags';
import useMobile from 'common/hooks/useMobile';
import { getIsDarkModeSelector } from 'common/redux/userSettings/userSettingsSlice';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

type Props = {
  isPanelOpened: boolean;
};

const PanelButton: FC<Props> = ({ isPanelOpened }) => {
  const isMobile = useMobile();
  const darkMode = useSelector(getIsDarkModeSelector);
  const commentIconName = useMemo(() => {
    if (isReportLivePreview) {
      return 'close';
    }
    return isPanelOpened ? 'right-chevron' : 'comment-chevron-left';
  }, [isPanelOpened]);

  const commentIconWidth = isPanelOpened ? 15 : 30;
  const icon = (
    <Icon
      name={commentIconName}
      className="fill icon-orange"
      width={isReportLivePreview ? '18' : commentIconWidth.toString()}
    />
  );

  if (isReportLivePreview && !isMobile) {
    return icon;
  }
  if (isReportLivePreview && isMobile) {
    if (darkMode) {
      return <Icon name="tooltip-close-darkMode" width="34" height="32" />;
    }
    return <Icon name="tooltip-close-lightMode" width="34" height="32" />;
  }

  if (!isPanelOpened) {
    return (
      <Tooltip
        direction="bottom"
        tip="Comments"
        dataTestId={undefined}
        unthemed={undefined}
        showingInitial={undefined}
      >
        {icon}
      </Tooltip>
    );
  }

  return icon;
};

export default PanelButton;
